<div class="match-search" [class.match-search--expanded]="expanded()" (focusout)="onFocusOut($event)">
  <button
    type="button"
    class="match-search__toggle"
    aria-controls="sportsbook-search-field"
    [attr.aria-expanded]="expanded()"
    [attr.aria-label]="(expanded() ? 'search.close' : 'search.open') | translate"
    (click)="toggleExpanded.emit()"
  >
    <span class="material-symbols-outlined match-search__toggle-icon" aria-hidden="true">search</span>
  </button>

  <label
    id="sportsbook-search-field"
    class="match-search__field"
    [attr.aria-hidden]="!expanded()"
    [attr.inert]="!expanded() ? '' : null"
  >
    <span class="match-search__label">{{ 'search.label' | translate }}</span>
    <input
      #searchInput
      type="text"
      class="match-search__input"
      autocomplete="off"
      [value]="query()"
      [attr.aria-label]="'search.label' | translate"
      [attr.placeholder]="'search.placeholder' | translate"
      (input)="onInput($event)"
      (keydown)="onEscape($event)"
    />

    @if (query().trim().length > 0) {
      <button
        type="button"
        class="match-search__clear"
        [attr.aria-label]="'search.clear' | translate"
        (mousedown)="onClearMouseDown($event)"
        (click)="onClear()"
      >
        <span class="material-symbols-outlined match-search__clear-icon" aria-hidden="true">close</span>
      </button>
    }
  </label>
</div>
